import React, {Component} from 'react';
import {InputNumber ,Form} from "antd";

class NormalInputNumber extends Component {

    static defaultProps = {
        maxLength: 300
    };

    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }


    render() {
        return (
            <Form.Item label={this.props.label} required={this.props.empty} style={{display:"flex"}}>
                <InputNumber min={this.props.min} max={this.props.max}
                             placeholder={"请输入"}
                             bordered={false}
                             className={"normalInput"}
                             disabled={this.props.disabled?this.props.disabled:false}
                             value={this.props.value}
                             style={{width:this.props.width?this.props.width:"266px"}} onChange={(e)=>{
                                this.props.callBack && this.props.callBack(e)
                }}/>
                <style>{`.normalInput{background: rgba(0, 80, 179, 0.04);border: "1px solid rgba(0, 80, 179, 0.08)}
                           
                
                `}</style>
            </Form.Item>
        );
    }
}

export default NormalInputNumber;
